import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { giftCardDeactivation } from 'actions/EntityActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class POSGiftCardDeactivation extends Component {
    constructor(props, context) {
        super(props, context);
    }

    giftCardDeactivation = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            Pan: p.pan,
            Expdate: p.expdate,
            CvdValue: p.cvdValue,
            OrderId: `${this.props.store.monerisStoreId}${new Date().getTime()}`,
            TerminalId: p.terminalId,
            ProcessMethod: p.proceddMethod === true ? 1 : 0
        };
        this.props.giftCardDeactivation(model);
    }

    render() {
        const { t } = this.props; 
        let p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose style="pink" text={t('pos.giftCard.deactivation.label')} handleClose={() => this.props.onCancel()}/>}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.giftCardDeactivation()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <ToggleInput className="giftCard_process_method" name={`${p.name}processMethod`} label={t('pos.giftCard.processMethod.label')} option1={t('pos.giftCard.deactivation.swipe')} option2={t('common.type')} />
                    </div>
                    {
                        this.props.proceddMethod ?
                        (
                            <React.Fragment>
                                <h5>{t('pos.giftCard.deactivation.fillUpInfo')}</h5>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}pan`}
                                            fullWidth={true}
                                            label={t('common.cardNum')}
                                            floatingLabelText={t('common.cardNum')}
                                            hintText={t('common.cardNum')} />
                                    </div>
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}expdate`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.expdateWithFormat.label')}
                                            floatingLabelText={t('pos.giftCard.expdateWithFormat.label')}
                                            hintText={t('pos.giftCard.expdateWithFormat.hintText')} />
                                    </div>
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}cvdValue`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.cvdValue.label')}
                                            floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                            hintText={t('pos.giftCard.cvdValue.hintText')} />
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                        :
                        (
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h5>{t('pos.giftCard.readyToSwipeCard.text')}</h5>
                                <TextInput name={`${p.name}cvdValue`}
                                    fullWidth={true}
                                    label={t('pos.giftCard.cvdValue.label')}
                                    floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                    hintText={t('pos.giftCard.cvdValue.hintText')} />
                            </div>
                        )
                    }


                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        pan: state.form[`POSGiftCardDeactivationpan`] || '',
        expdate: state.form[`POSGiftCardDeactivationexpdate`] || '',
        cvdValue: state.form[`POSGiftCardDeactivationcvdValue`] || '',
        store: state.common.store,
        proceddMethod: state.form[`POSGiftCardDeactivationprocessMethod`],
        terminalId: state.entity.cashFlow ? state.entity.cashFlow.terminalId : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        giftCardDeactivation: (model) => dispatch(giftCardDeactivation(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCardDeactivation));